/**
 * Dates on the admin page, in the reader's own locale-free house format. UTC, so a
 * run that finished at 02:25 reads as 02:25 for everyone rather than for whoever
 * happens to be in a different offset.
 */

const DATE = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' });
const DATE_TIME = new Intl.DateTimeFormat('en-GB', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  timeZone: 'UTC',
});

const parse = (value: string | undefined): Date | undefined => {
  if (value === undefined) {
    return undefined;
  }

  const date = new Date(value);

  return Number.isNaN(date.getTime()) ? undefined : date;
};

/** `23 Sept 2026`, or `undefined` for a value that is absent or not a date. */
export const formatDate = (value: string | undefined): string | undefined => {
  const date = parse(value);
  return date === undefined ? undefined : DATE.format(date);
};

/** `23 Sept 2026, 02:25 UTC`. */
export const formatDateTime = (value: string | undefined): string | undefined => {
  const date = parse(value);
  return date === undefined ? undefined : `${DATE_TIME.format(date)} UTC`;
};

/** Whether a date such as `2026-12-01` is within `days` days of `now`, or already past. */
export const isExpiringWithin = (value: string | undefined, days: number, now: Date = new Date()): boolean => {
  const date = parse(value);
  return date !== undefined && date.getTime() - now.getTime() < days * 24 * 60 * 60 * 1000;
};
